import '../../css/style.scss'
import '../../css/leaderboard.scss'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {Sound} from '../../../shared/scripts/Sound'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController'
import {UIWLeaderboardController} from './UIWLeaderboardController'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'

void init()

async function init() {
    Sound.loadSounds()

    await EntryShared.initializeEntry()

    const headerController = new UIWHeaderController()
    new UISidebarController()

    new UIWLeaderboardController()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}
